import { Container, Grid, Typography, Box, Button } from '@mui/material';
import { getImageUrl } from '../../utils';

const personalTrainingImage = getImageUrl('pt-3.png');

const PersonalTraining = () => (
  <Box sx={{ background: 'linear-gradient(to bottom, #ffffff, #fdfdfd)', py: { xs: 6, md: 8 } }}>
    <Container maxWidth="lg">
      <Grid container spacing={6} alignItems="center">
        {/* Text Block */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backdropFilter: 'blur(10px)',
              backgroundColor: 'rgba(255, 255, 255, 0.6)',
              p: { xs: 3, md: 4 },
              borderRadius: '1rem',
              boxShadow: '0 8px 24px rgba(0,0,0,0.05)',
            }}
          >
            <Typography
              variant="overline"
              sx={{
                color: '#00b5bf',
                fontWeight: 600,
                fontSize: '0.9rem',
                letterSpacing: '1px',
                mb: 1,
              }}
            >
              Nå dina mål
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontFamily: 'var(--font-heading)',
                fontWeight: 700,
                color: '#222',
                fontSize: { xs: '2rem', md: '2.5rem' },
                mb: 2,
              }}
            >
              Personlig Träning
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: '#444',
                fontSize: { xs: '1rem', md: '1.125rem' },
                lineHeight: 1.8,
                mb: 4,
              }}
            >
              Få en skräddarsydd träningsupplevelse med fullt fokus på dig. Våra personliga tränare
              hjälper dig att bygga styrka, balans och självförtroende – i din takt.
            </Typography>

            <Button
              variant="contained"
              href="/sidepages/personaltraining-info"
              sx={{
                background: 'linear-gradient(135deg, #00b5bf, #429398)',
                color: 'white',
                px: 4,
                py: 1.5,
                borderRadius: '999px',
                fontWeight: 600,
                fontSize: '1rem',
                textTransform: 'none',
                boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)',
                 '&:hover': {
                      transform: 'translateY(-2px)',
                      background: 'linear-gradient(135deg, #007C85, #357f87)',
                    },
              }}
            >
              Se Mer
            </Button>
          </Box>
        </Grid>

        {/* Image Block */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              borderRadius: '1rem',
              overflow: 'hidden',
              boxShadow: '0 10px 24px rgba(0,0,0,0.1)',
              transition: 'transform 0.3s ease-in-out',
              '&:hover': {
                transform: 'scale(1.03)',
              },
            }}
          >
            <Box
              sx={{
                height: { xs: 300, md: 420 },
                width: '100%',
                backgroundImage: `url(${personalTrainingImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default PersonalTraining;
